import script from "./ZPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ZPagination.vue?vue&type=script&setup=true&lang=js"

import "./index.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__